import type { Chain } from './AUTO_GENERATED/chains'

export const FRAXTAL_CHAIN_ID = '252'

export const FRAXTAL_GATEWAY_URL =
  process.env.NEXT_PUBLIC_FRAXTAL_GATEWAY_URL || 'https://safe-gateway.mainnet.frax.com'

export const EXTRA_CHAIN_CONFIGS: Chain[] = [
  {
    chainId: FRAXTAL_CHAIN_ID,
    chainName: 'Fraxtal',
    description: '',
    chainLogoUri: 'https://fraxchain-mainnet-safe.s3.amazonaws.com/chains/252/chain_logo.png',
    l2: true,
    isTestnet: false,
    zk: false,
    nativeCurrency: {
      name: 'Frax',
      symbol: 'FRAX',
      decimals: 18,
      logoUri: 'https://fraxchain-mainnet-safe.s3.amazonaws.com/chains/252/currency_logo.png',
    },
    transactionService: 'https://safe.mainnet.frax.com/txs',
    blockExplorerUriTemplate: {
      address: 'https://fraxscan.com/address/{{address}}',
      txHash: 'https://fraxscan.com/tx/{{txHash}}',
      api: 'https://fraxscan.com/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    beaconChainExplorerUriTemplate: {
      publicKey: null,
    },
    disabledWallets: [],
    ensRegistryAddress: null,
    balancesProvider: {
      chainName: null,
      enabled: false,
    },
    features: [
      'CONTRACT_INTERACTION',
      'ERC1155',
      'ERC721',
      'NATIVE_WALLETCONNECT',
      'PROPOSERS',
      'SAFE_APPS',
      'SPENDING_LIMIT',
      'TX_SIMULATION',
    ],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://rpc.frax.com/',
    },
    rpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://rpc.frax.com/',
    },
    safeAppsRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://rpc.frax.com/',
    },
    shortName: 'fraxtal',
    theme: {
      textColor: '#ffffff',
      backgroundColor: '#000000',
    },
    recommendedMasterCopyVersion: '1.3.0',
  },
]

export const getChainGatewayOverrideUrl = (url: string): string | undefined => {
  if (/^\/v[12]\/chains\/252(?:\/|\?|$)/.test(url)) {
    return FRAXTAL_GATEWAY_URL
  }
}

export const normalizeChainGatewayOverridePath = (url: string): string => {
  // Frax's Safe gateway currently exposes chain 252 through the v1 route set.
  return url.replace(/^\/v2\/chains\/252(?=\/|\?|$)/, '/v1/chains/252')
}
